"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgregationModal = exports.agregation = exports.desagregation = exports.updateLayout = exports.reorganize_all_input_outputLinksId = exports.compute_auto_sankey = exports.arrangeNodes = exports.explore_branch = exports.apply_input_outputLinksId = exports.compute_default_input_outputLinksId = exports.reorganize_inputLinksId = exports.reorganize_node_outputLinksId = exports.reorganize_node_inputLinksId = void 0;
const types_1 = require("./types");
const SankeyUtils_1 = require("./SankeyUtils");
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_bootstrap_1 = require("react-bootstrap");
const reorganize_node_inputLinksId = (node, nodes, links) => {
    const input_links = Object.values(links).filter(l => l.idTarget === node.idNode);
    input_links.sort((l1, l2) => {
        const n1Id = l1.idSource;
        const n2Id = l2.idSource;
        if (n1Id !== n2Id) {
            const n1 = nodes[n1Id];
            const n2 = nodes[n2Id];
            if (n2.position == 'relative') {
                return 1;
            }
            if (n1.position == 'relative') {
                return -1;
            }
            if (l1.recycling && !l2.recycling) {
                if (l1.vert_shift && l1.vert_shift < 0) {
                    return -1;
                }
                return 1;
            }
            if (!l1.recycling && l2.recycling) {
                if (l2.vert_shift && l2.vert_shift < 0) {
                    return 1;
                }
                return -1;
            }
            if (l1.orientation === 'vh' && l2.orientation === 'vh' || l1.orientation === 'vv' && l2.orientation === 'vv') {
                if (n1 && n2 && n1.x < n2.x) {
                    return -1;
                }
                return 1;
            }
            if (n1 && n2 && n1.y < n2.y) {
                return -1;
            }
            return 1;
        }
        else {
            const n1 = nodes[n1Id];
            if (n1) {
                const output_l1_index = n1.outputLinksId.indexOf(l1.idLink);
                const output_l2_index = n1.outputLinksId.indexOf(l2.idLink);
                const l1_index = input_links.indexOf(l1);
                const l2_index = input_links.indexOf(l1);
                if ((output_l1_index < output_l2_index && l1_index < l2_index) ||
                    (output_l1_index > output_l2_index && l1_index > l2_index)) {
                    return 1;
                }
                return -1;
            }
            else {
                return 1;
            }
        }
    });
    node.inputLinksId = input_links.map(l => l.idLink);
};
exports.reorganize_node_inputLinksId = reorganize_node_inputLinksId;
const reorganize_node_outputLinksId = (node, nodes, links) => {
    const output_links = Object.values(links).filter(l => l.idSource === node.idNode);
    output_links.sort((l1, l2) => {
        const n1Id = l1.idTarget;
        const n2Id = l2.idTarget;
        if (n1Id !== n2Id) {
            const n1 = nodes[n1Id];
            const n2 = nodes[n2Id];
            if (n2.position == 'relative') {
                return -1;
            }
            if (n1.position == 'relative') {
                return 1;
            }
            if (l1.recycling && !l2.recycling) {
                if (l1.vert_shift && l1.vert_shift < 0) {
                    return 1;
                }
                return -1;
            }
            if (!l1.recycling && l2.recycling) {
                if (l2.vert_shift && l2.vert_shift < 0) {
                    return 1;
                }
                return -1;
            }
            if (l1.orientation === 'vh' && l2.orientation === 'vh' || l1.orientation === 'vv' && l2.orientation === 'vv') {
                if (n1 && n2 && n1.x < n2.x) {
                    return -1;
                }
                return 1;
            }
            if (n1 && n2 && n1.y < n2.y) {
                return -1;
            }
            return 1;
        }
        else {
            const n1 = nodes[n1Id];
            if (n1) {
                const input_l1_index = n1.inputLinksId.indexOf(l1.idLink);
                const input_l2_index = n1.inputLinksId.indexOf(l2.idLink);
                const l1_index = output_links.indexOf(l1);
                const l2_index = output_links.indexOf(l1);
                if ((input_l1_index < input_l2_index && l1_index < l2_index) ||
                    (input_l1_index > input_l2_index && l1_index > l2_index)) {
                    return 1;
                }
                return -1;
            }
            else {
                return 1;
            }
        }
    });
    node.outputLinksId = output_links.map(l => l.idLink);
};
exports.reorganize_node_outputLinksId = reorganize_node_outputLinksId;
const reorganize_inputLinksId = (node, input, output, nodes, links) => {
    if (input) {
        exports.reorganize_node_inputLinksId(node, nodes, links);
    }
    if (output) {
        exports.reorganize_node_outputLinksId(node, nodes, links);
    }
};
exports.reorganize_inputLinksId = reorganize_inputLinksId;
const compute_default_input_outputLinksId = (nodes, links) => {
    Object.values(nodes).forEach(n => {
        n.inputLinksId = [];
        n.outputLinksId = [];
    });
    Object.values(links).forEach(link => {
        nodes[link.idTarget].inputLinksId.push(link.idLink);
        nodes[link.idSource].outputLinksId.push(link.idLink);
    });
};
exports.compute_default_input_outputLinksId = compute_default_input_outputLinksId;
const normalize_name = (name) => {
    const new_name = name.split('\\n').join('').split(' ').join('');
    return new_name;
};
const apply_input_outputLinksId = (ref_nodes, ref_links, data) => {
    const display_nodes = data.nodes;
    const display_links = data.links;
    Object.values(ref_nodes).forEach((ref_node) => {
        const nodes_found = Object.values(display_nodes).filter(n => {
            return normalize_name(ref_node.name) === normalize_name(n.name);
        });
        if (nodes_found.length === 0) {
            return;
        }
        const node = nodes_found[0];
        const new_inputLinksId = [];
        ref_node.inputLinksId.forEach((idLink) => {
            const ref_link = ref_links[idLink];
            if (ref_link === undefined) {
                return;
            }
            const links = Object.values(display_links).filter(l => {
                return normalize_name(data.nodes[l.idSource].name) === normalize_name(ref_nodes[ref_link.idSource].name) &&
                    normalize_name(data.nodes[l.idTarget].name) === normalize_name(ref_nodes[ref_link.idTarget].name);
            });
            if (links.length === 0) {
                return;
            }
            new_inputLinksId.push(links[0].idLink);
        });
        node.inputLinksId = new_inputLinksId; //result_inputLinksId.filter(function (item, pos) {return node.inputLinksId.indexOf(item) == pos})
        const new_outputLinksId = [];
        ref_node.outputLinksId.forEach((idLink) => {
            const ref_link = ref_links[idLink];
            if (ref_link === undefined) {
                return;
            }
            const links = Object.values(display_links).filter(l => {
                return normalize_name(data.nodes[l.idSource].name) === normalize_name(ref_nodes[ref_link.idSource].name) &&
                    normalize_name(data.nodes[l.idTarget].name) === normalize_name(ref_nodes[ref_link.idTarget].name);
            });
            if (links.length === 0) {
                return;
            }
            new_outputLinksId.push(links[0].idLink);
        });
        node.outputLinksId = new_outputLinksId; //result_outputLinksId.filter(function (item, pos) {return node.outputLinksId.indexOf(item) == pos})
    });
};
exports.apply_input_outputLinksId = apply_input_outputLinksId;
const explore_branch = (idNode, current_length, visited_nodes, links, nodes) => {
    let no_input_link = true;
    let highest_branch_length = current_length;
    Object.values(links).forEach(link => {
        if (link.idTarget === idNode && nodes[link.idSource].node_visible && nodes[link.idSource].display) {
            if (visited_nodes.indexOf(idNode) === -1) {
                no_input_link = false;
                const branch_length = exports.explore_branch(link.idSource, current_length + 1, [...visited_nodes, idNode], links, nodes);
                if (branch_length > highest_branch_length) {
                    highest_branch_length = branch_length;
                }
            }
        }
    });
    if (no_input_link === true) {
        return current_length;
    }
    else {
        return highest_branch_length;
    }
};
exports.explore_branch = explore_branch;
const arrangeNodes = (data) => {
    Object.values(data.nodes).forEach(node => {
        if (!node.node_visible || node.position === 'relative') {
            return;
        }
        const x = Math.round(node.x / data.grid_square_size) * data.grid_square_size;
        const y = Math.round(node.y / data.grid_square_size) * data.grid_square_size;
        node.x = x;
        node.y = y;
    });
};
exports.arrangeNodes = arrangeNodes;
const compute_auto_sankey = (data, h_space) => {
    let max_horizontal_index = 0;
    let max_link_value = 0;
    Object.values(data.links).forEach(link => {
        const new_max_link_value = SankeyUtils_1.findMaxLinkValue(max_link_value, link.value);
        max_link_value = new_max_link_value > max_link_value ? new_max_link_value : max_link_value;
    });
    max_link_value += 1;
    if (max_link_value !== 1) {
        data.user_scale = max_link_value;
    }
    const vspace = data.v_space;
    const horizontal_indices = {};
    Object.values(data.nodes).filter(n => n.node_visible).forEach(node => {
        const horizontal_index = exports.explore_branch(node.idNode, 0, [], data.links, data.nodes);
        horizontal_indices[node.idNode] = horizontal_index;
        if (horizontal_index > max_horizontal_index) {
            max_horizontal_index = horizontal_index;
        }
    });
    Object.values(data.links).filter(l => data.nodes[l.idSource].node_visible && data.nodes[l.idTarget].node_visible && data.nodes[l.idSource].display && data.nodes[l.idTarget].display).forEach(l => {
        if (horizontal_indices[l.idSource] >= horizontal_indices[l.idTarget]) {
            l.recycling = true;
        }
    });
    const width = max_horizontal_index * h_space;
    Object.values(data.nodes).forEach(node => {
        if (!node.node_visible || !node.display) {
            return;
        }
        node.x = max_horizontal_index !== 0 ? 50 + horizontal_indices[node.idNode] / max_horizontal_index * width : 50; //* 0.9
    });
    // Reorder links using the x of source name as criteria 
    // Compute input_outputLinksId
    Object.values(data.nodes).filter(n => n.node_visible && n.display).forEach(n => data.nodes[n.idNode] = Object.assign({}, n));
    exports.compute_default_input_outputLinksId(data.nodes, data.links);
    // Vertical position of vertical nodes
    // compute total height of nodes that belong to the same column, then compute the spaces between them and their positions.
    let max_vertical_offset = 0;
    for (let i = 0; i <= max_horizontal_index; i++) {
        let vertical_space;
        let vertical_offset = 0;
        const the_nodes = Object.values(data.nodes).filter(n => n.node_visible && n.display && horizontal_indices[n.idNode] === i);
        if (the_nodes.length > 1) {
            vertical_space = vspace; //(200 - total_height) / (total_nb - 1)
        }
        else {
            vertical_space = 0;
        }
        the_nodes.forEach((node, node_id) => {
            if (node_id === 0) {
                node.y = 200; //0.2 * height;
                vertical_offset = 200 + vertical_space;
            }
            else {
                node.y = vertical_offset;
                vertical_offset += vertical_space;
            }
        });
        if (max_vertical_offset < vertical_offset) {
            max_vertical_offset = vertical_offset;
        }
    }
    for (let i = 0; i <= max_horizontal_index; i++) {
        const the_nodes = Object.values(data.nodes).filter(n => n.node_visible && n.display && horizontal_indices[n.idNode] === i);
        let total_nb_outputLinksId_up = 0;
        let total_nb_outputLinksId_down = 0;
        the_nodes.forEach((node) => {
            node.outputLinksId.forEach((idLink) => {
                if (data.nodes[data.links[idLink].idSource].node_visible && data.nodes[data.links[idLink].idTarget].node_visible && data.nodes[data.links[idLink].idSource].display && data.nodes[data.links[idLink].idTarget].display) {
                    const target_node = data.nodes[data.links[idLink].idTarget];
                    if (target_node === undefined) {
                        return;
                    }
                    if (target_node.y < node.y) {
                        total_nb_outputLinksId_up += 1;
                    }
                    else {
                        total_nb_outputLinksId_down += 1;
                    }
                }
            });
        });
        let current_output_link_up = 0;
        let current_output_link_down = 0;
        the_nodes.forEach(node => {
            node.outputLinksId.forEach((idLink) => {
                if (data.nodes[data.links[idLink].idSource].node_visible && data.nodes[data.links[idLink].idTarget].node_visible && data.nodes[data.links[idLink].idSource].display && data.nodes[data.links[idLink].idTarget].display) {
                    const target_node = data.nodes[data.links[idLink].idTarget];
                    if (target_node === undefined) {
                        return;
                    }
                    if (target_node.y < node.y) {
                        data.links[idLink].left_horiz_shift = data.left_shift + (current_output_link_up / total_nb_outputLinksId_up) * data.max_shift;
                        data.links[idLink].right_horiz_shift = data.right_shift + (current_output_link_up / total_nb_outputLinksId_up) * data.max_shift;
                        current_output_link_up += 1;
                    }
                    else {
                        data.links[idLink].left_horiz_shift = data.left_shift - (current_output_link_down / total_nb_outputLinksId_down) * data.max_shift;
                        data.links[idLink].right_horiz_shift = data.right_shift - (current_output_link_down / total_nb_outputLinksId_down) * data.max_shift;
                        current_output_link_down += 1;
                    }
                }
            });
        });
    }
    data.width = width + h_space;
    exports.reorganize_all_input_outputLinksId(data.nodes, data.links);
    return [];
};
exports.compute_auto_sankey = compute_auto_sankey;
const reorganize_all_input_outputLinksId = (nodes, links) => {
    Object.values(nodes).forEach(node => {
        exports.reorganize_node_inputLinksId(node, nodes, links);
        exports.reorganize_node_outputLinksId(node, nodes, links);
    });
};
exports.reorganize_all_input_outputLinksId = reorganize_all_input_outputLinksId;
const updateLayout = (data, new_layout, mode) => {
    let max_vertical_offset = 0;
    const compute_offset = (node) => {
        if (!node.node_visible) {
            return;
        }
        max_vertical_offset = Math.max(node.y, max_vertical_offset);
    };
    Object.values(data.nodes).forEach(compute_offset);
    max_vertical_offset = max_vertical_offset + 200;
    //data.node_width = new_layout.node_width
    // Apply nodes layout
    for (const node_layout_key in new_layout.nodes) {
        const node_layout = new_layout.nodes[node_layout_key];
        const nodes = Object.values(data.nodes).filter(n => normalize_name(n.name) === normalize_name(node_layout.name));
        let node;
        if (nodes.length === 0) {
            if (node_layout.inputLinksId.length === 0 && node_layout.outputLinksId.length === 0 && node_layout.shape_visible === false && node_layout.label_visible === true) {
                // Case of not a label
                node = Object.assign({}, node_layout);
                // Méthode pour incrementer idNode
                const listId = [];
                Object.keys(data.nodes).forEach(elt => listId.push(Number(elt.replace('node', ''))));
                const idNode = listId.length > 0 ? Math.max(...listId) + 1 : 0;
                node.idNode = 'idNode' + idNode;
                data.nodes[node.idNode];
            }
            else {
                continue;
            }
        }
        node = nodes[0];
        if (!node) {
            continue;
        }
        if (mode.includes('posNode')) {
            node.name = node_layout.name;
            node.position = node_layout.position;
            node.node_width = node_layout.node_width;
            node.node_height = node_layout.node_height;
            node.show_value = node_layout.show_value;
            node.shape = node_layout.shape;
            if (node_layout.x !== 0 && node_layout.y != 0) {
                node.x = node_layout.x;
                node.y = node_layout.y;
            }
            if (node.y + 200 > max_vertical_offset) {
                max_vertical_offset = node.y + 200;
            }
            node.x_label = node_layout.x_label;
            node.y_label = node_layout.y_label;
        }
        if (mode.includes('attrNode')) {
            node.display_style = Object.assign({}, node_layout.display_style);
            // node.iconName = node_layout.iconName ? node_layout.iconName : node.iconName
            // node.iconColor = node_layout.iconColor ? node_layout.iconColor : node.iconColor
            // node.iconRatio = node_layout.iconRatio ? node_layout.iconRatio : node.iconRatio
            // node.iconVisible= node_layout.iconVisible ? node_layout.iconVisible : node.iconVisible
            node.colorTag = node_layout.colorTag;
            node.colorParameter = node_layout.colorParameter;
            node.color = node_layout.color;
            node.shape_visible = node_layout.shape_visible;
            node.node_visible = node_layout.node_visible;
            node.label_visible = node_layout.label_visible;
        }
        // if(mode.includes('tagNode')){
        //   for (const node_tag_key in node_layout.tags) {
        //     node.tags[node_tag_key] = JSON.parse(JSON.stringify(node_layout.tags[node_tag_key]))
        //   }
        // }    
    }
    data.labels = {};
    for (const layout_label in new_layout.labels) {
        data.labels[layout_label] =
            new_layout.labels[layout_label];
    }
    if (mode.includes('attrFlux')) {
        exports.apply_input_outputLinksId(new_layout.nodes, new_layout.links, data);
        for (const link_layout_key in new_layout.links) {
            const link_layout = new_layout.links[link_layout_key];
            const links = Object.values(data.links).filter(l => {
                return normalize_name(data.nodes[l.idSource].name) === normalize_name(new_layout.nodes[link_layout.idSource].name) &&
                    normalize_name(data.nodes[l.idTarget].name) === normalize_name(new_layout.nodes[link_layout.idTarget].name);
            });
            if (links.length === 0) {
                continue;
            }
            const link = links[0];
            const { x_label, y_label, label_position, label_visible, recycling, curved, curvature, arrow, orthogonal_label_position, label_font_size } = link_layout;
            link.curvature = curvature;
            link.curved = curved;
            link.arrow = arrow;
            link.text_color = link_layout.text_color;
            link.label_position = label_position;
            link.label_visible = label_visible;
            link.label_font_size = label_font_size;
            link.x_label = x_label;
            link.y_label = y_label;
            link.left_horiz_shift = link_layout.left_horiz_shift;
            link.right_horiz_shift = link_layout.right_horiz_shift;
            link.orientation = link_layout.orientation;
            link.recycling = recycling;
            link.orthogonal_label_position = orthogonal_label_position;
            link.colorTag = link_layout.colorTag;
            link.colorParameter = link_layout.colorParameter;
            link.color = link_layout.color;
            if (link_layout.vert_shift) {
                link.left_horiz_shift = link_layout.left_horiz_shift;
                link.right_horiz_shift = link_layout.right_horiz_shift;
                link.vert_shift = link_layout.vert_shift;
            }
        }
    }
    if (new_layout.view) {
        if (!data.view) {
            data.view = [];
        }
        new_layout.view.forEach(v => data.view.push(v));
    }
    if (mode.includes('tagNode')) {
        for (const tag_group_key in new_layout.nodeTags) {
            if (tag_group_key in data.nodeTags) {
                continue;
            }
            data.nodeTags[tag_group_key] = JSON.parse(JSON.stringify(new_layout.nodeTags[tag_group_key]));
        }
        for (const tag_group_key in data.nodeTags) {
            if (!(tag_group_key in new_layout.nodeTags)) {
                continue;
            }
            data.nodeTags[tag_group_key].show_legend = new_layout.nodeTags[tag_group_key].show_legend;
            data.nodeTags[tag_group_key].banner = new_layout.nodeTags[tag_group_key].banner;
            for (const tag in data.nodeTags[tag_group_key].tags) {
                if (!(tag in new_layout.nodeTags[tag_group_key].tags)) {
                    continue;
                }
                data.nodeTags[tag_group_key].tags[tag].color = new_layout.nodeTags[tag_group_key].tags[tag].color;
                if (tag !== 'échange') {
                    data.nodeTags[tag_group_key].tags[tag].selected = new_layout.nodeTags[tag_group_key].tags[tag].selected;
                }
            }
        }
    }
    if (mode.includes('tagFlux')) {
        for (const tag_group_key in new_layout.fluxTags) {
            data.fluxTags[tag_group_key] = JSON.parse(JSON.stringify(new_layout.fluxTags[tag_group_key]));
        }
        for (const tag_group_key in data.fluxTags) {
            if (!(tag_group_key in new_layout.fluxTags)) {
                continue;
            }
            data.fluxTags[tag_group_key].show_legend = new_layout.fluxTags[tag_group_key].show_legend;
            data.fluxTags[tag_group_key].banner = new_layout.fluxTags[tag_group_key].banner;
            for (const tag in data.fluxTags[tag_group_key].tags) {
                if (!(tag in new_layout.fluxTags[tag_group_key].tags)) {
                    continue;
                }
                data.fluxTags[tag_group_key].tags[tag].color = new_layout.fluxTags[tag_group_key].tags[tag].color;
                data.fluxTags[tag_group_key].tags[tag].selected = new_layout.fluxTags[tag_group_key].tags[tag].selected;
            }
        }
    }
    // data.agregation.level = new_layout.agregation.level
    // data.agregation.dimension = new_layout.agregation.dimension
    if (mode.includes('attrGeneral')) {
        // data.icon_catalog = new_layout.icon_catalog
        data.colorMap = new_layout.colorMap;
        data.user_scale = new_layout.user_scale;
        data.legend_position = new_layout.legend_position;
        data.welcome_text = new_layout.welcome_text;
        data.accordeonToShow = new_layout.accordeonToShow;
        if ('width' in new_layout) {
            data.width = new_layout.width;
        }
        if (new_layout.maximum_flux) {
            data.maximum_flux = new_layout.maximum_flux;
        }
        Object.keys(new_layout.display_style).forEach(key => data.display_style[key] = new_layout.display_style[key]);
        if (data.display_style.filter === undefined) {
            data.display_style.filter = 0;
        }
        if (data.display_style.filter_label === undefined) {
            data.display_style.filter_label = 0;
        }
    }
    SankeyUtils_1.set_nodes_level(data);
};
exports.updateLayout = updateLayout;
const desagregation = (data, idNode, cur_dimension, control_display = true) => {
    const dim_desagregate_nodes = Object.values(data.nodes).filter(n => n.dimensions[cur_dimension] && n.dimensions[cur_dimension].parent_name === idNode);
    if (dim_desagregate_nodes.length == 0) {
        return;
    }
    if (control_display) {
        dim_desagregate_nodes.forEach(n => {
            n.display = true;
            n.node_visible = true;
        });
    }
    const nb_desagregated = dim_desagregate_nodes.length;
    let current_y = data.v_space / 2;
    const delta_y = data.v_space / (nb_desagregated - 1);
    dim_desagregate_nodes.forEach(n => {
        if ((n.x === undefined || (n.x === 0 || n.y === 0)) && (data.nodes[idNode].x !== 0 && data.nodes[idNode].y !== 0)) {
            n.x = data.nodes[idNode].x;
            n.y = data.nodes[idNode].y - current_y;
        }
        current_y = current_y - delta_y;
    });
    if (control_display) {
        // Hides agregated nodes
        data.nodes[idNode].display = false;
        data.nodes[idNode].node_visible = false;
    }
};
exports.desagregation = desagregation;
const agregation = (data, idNode, cur_dimension, control_display = true) => {
    var _a;
    if (!(cur_dimension in data.nodes[idNode].dimensions)) {
        return;
    }
    const desagregated_node = data.nodes[idNode];
    const parent_node = data.nodes[(_a = desagregated_node.dimensions[cur_dimension].parent_name) !== null && _a !== void 0 ? _a : ''];
    if (!parent_node) {
        return;
    }
    const cur_parentId = desagregated_node.dimensions[cur_dimension].parent_name;
    const dim_desagregated_nodes = Object.values(data.nodes).filter(n => {
        const cur_n_dim = n.dimensions[cur_dimension];
        return cur_n_dim && (cur_n_dim.parent_name === cur_parentId ||
            (cur_n_dim.parent_name && data.nodes[cur_n_dim.parent_name].dimensions[cur_dimension] && data.nodes[cur_n_dim.parent_name].dimensions[cur_dimension].parent_name === cur_parentId));
    });
    if (control_display) {
        // show agregated node
        parent_node.display = true;
        parent_node.node_visible = true;
    }
    if (dim_desagregated_nodes.length === 0) {
        return;
    }
    let mean_x = 0;
    let mean_y = 0;
    dim_desagregated_nodes.forEach(n => {
        if (control_display) {
            data.nodes[n.idNode].display = false;
            data.nodes[n.idNode].node_visible = false;
        }
        if (n.x) {
            mean_x += n.x;
            mean_y += n.y;
        }
    });
    mean_x = mean_x / dim_desagregated_nodes.length;
    mean_y = mean_y / dim_desagregated_nodes.length;
    if (parent_node.x === undefined || (parent_node.x === 0 && parent_node.y === 0)) {
        parent_node.x = mean_x;
        parent_node.y = mean_y;
    }
};
exports.agregation = agregation;
const AgregationModalPropTypes = {
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired,
    agregation_node: prop_types_1.default.string.isRequired,
    set_show_agregation: prop_types_1.default.func.isRequired,
    show_agregation: prop_types_1.default.bool.isRequired,
    is_agregation: prop_types_1.default.bool.isRequired
};
const AgregationModal = ({ data, set_data, agregation_node, set_show_agregation, show_agregation, is_agregation }) => {
    const n = data.nodes[agregation_node];
    const [dim_name, set_dim_name] = react_1.useState('');
    const [child_names, set_child_names] = react_1.useState([]);
    const dim_names = [];
    if (is_agregation) {
        Object.keys(n.dimensions).forEach(dim => {
            if (Object.keys(n.dimensions).length > 1 && dim === 'Primaire') {
                return;
            }
            if (n.dimensions[dim].parent_name) {
                //parent_names.push(n.dimensions[dim].parent_name as string)
                dim_names.push(dim);
            }
        });
        if (dim_name === '') {
            if (dim_names.length === 0) {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
            set_dim_name(dim_names[0]);
        }
        return (react_1.default.createElement(react_bootstrap_1.Modal, { show: show_agregation, onHide: () => {
                set_show_agregation(false);
                set_dim_name('');
            } },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Dimension d'agr\u00E9gation")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement(react_bootstrap_1.Form, null,
                    react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                        react_1.default.createElement(react_bootstrap_1.Row, null,
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => set_dim_name(evt.target.value) }, dim_names.map((cur_dir_name, i) => react_1.default.createElement("option", { key: i, value: cur_dir_name, selected: dim_name === cur_dir_name }, cur_dir_name))),
                                react_1.default.createElement(react_bootstrap_1.Form.Label, null, dim_name !== '' && data.nodes[n.dimensions[dim_name].parent_name] ? data.nodes[n.dimensions[dim_name].parent_name].name : '')))))),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => {
                        exports.agregation(data, agregation_node, dim_name);
                        set_data(Object.assign({}, data));
                        set_show_agregation(false);
                        set_dim_name('');
                    } }, "Agr\u00E9gation"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => {
                        set_show_agregation(false);
                        set_dim_name('');
                    } }, "Annuler"))));
    }
    else {
        Object.values(data.nodes).forEach(n2 => {
            for (const dim in n2.dimensions) {
                if (Object.keys(n2.dimensions).length > 1 && dim === 'Primaire') {
                    continue;
                }
                if (dim in n2.dimensions && n2.dimensions[dim].parent_name == n.idNode) {
                    if (dim_names.indexOf(dim) === -1) {
                        dim_names.push(dim);
                    }
                }
            }
            return false;
        });
        if (dim_name === '') {
            const the_child_names = [];
            Object.values(data.nodes).forEach(n2 => {
                if (dim_names[0] in n2.dimensions && n2.dimensions[dim_names[0]].parent_name == n.idNode) {
                    the_child_names.push(n2.name);
                }
            });
            set_dim_name(dim_names[0]);
            set_child_names(the_child_names);
        }
        return (react_1.default.createElement(react_bootstrap_1.Modal, { show: show_agregation, onHide: () => {
                set_show_agregation(false);
                set_dim_name('');
            } },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Dimension desagr\u00E9gation")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement(react_bootstrap_1.Form, null,
                    react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                        react_1.default.createElement(react_bootstrap_1.Row, null,
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => {
                                        set_dim_name(evt.target.value);
                                        const the_child_names = [];
                                        Object.values(data.nodes).forEach(n2 => {
                                            if (evt.target.value in n2.dimensions && n2.dimensions[evt.target.value].parent_name == n.idNode) {
                                                the_child_names.push(n2.name);
                                            }
                                        });
                                        set_child_names(the_child_names);
                                    } }, dim_names.map((cur_dim_name, i) => react_1.default.createElement("option", { key: i, value: cur_dim_name, selected: dim_name === cur_dim_name }, cur_dim_name))),
                                child_names.map(child_name => react_1.default.createElement(react_bootstrap_1.Form.Label, null, child_name))))))),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => {
                        exports.desagregation(data, agregation_node, dim_name);
                        set_data(Object.assign({}, data));
                        set_show_agregation(false);
                        set_dim_name('');
                    } }, "D\u00E9sagr\u00E9gation"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => {
                        set_show_agregation(false);
                        set_dim_name('');
                    } }, "Annuler"))));
    }
};
exports.AgregationModal = AgregationModal;
